import { useQuery } from '@tanstack/react-query'

import type { AllSellersData } from './api/getAllSellers'

/**
 * Fetches the (already hidden-storefront-filtered) seller list from our own
 * `/home-portal/api/all-sellers` route rather than calling `getAllSellers` directly, so the
 * filtering — including the server-only `getHiddenStorefrontPaths()` call — runs server-side.
 * See the route handler for why. The route lives under `/home-portal/api/`, not `/api/`,
 * because Cloudflare only routes `/home-portal/*` and `/_next/*` to this app in production.
 */
const fetchAllSellers = async (
  accessToken: string | null
): Promise<AllSellersData> => {
  const response = await fetch('/home-portal/api/all-sellers', {
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch all sellers: ${response.status}`)
  }

  return (await response.json()) as AllSellersData
}

export const useGetAllSellers = (accessToken: string | null = null) => {
  return useQuery({
    queryKey: ['getAllSellers', accessToken],
    queryFn: () => fetchAllSellers(accessToken),
    staleTime: 5 * 60 * 1000,
  })
}
